import { AxiosPromise } from 'axios';
import { IResetCurrentPasswordCommand } from './types';
import { instance } from '../../services/api';

export default (data: IResetCurrentPasswordCommand): AxiosPromise =>
  instance.post(`api/accounts/resetCurrent`, data);
